/* 甘寧傳・第 1 章：夏口・射殺凌操（建安八年，203）
 * 史實：〈甘寧傳〉正文：「少有氣力，好游俠……負毦帶鈴，民聞鈴聲，即知是寧。」「乃往依劉表……後轉託黃祖，祖又以凡人畜之。」
 *       注引《吳書》：「住止常以繒錦維舟，去或割棄，以示奢也。」（錦帆賊的由來）
 *       注引《吳書》：「權討祖，祖軍敗奔走，追兵急，寧以善射，將兵在後，射殺校尉凌操。祖旣得免，軍罷還營，待寧如初。」
 *       〈凌統傳〉：凌操「入夏口，先登，破其前鋒，輕舟獨進，中流矢死」。
 * 流程：黃祖的敗軍沿北岸大路往西退回夏口營，甘寧帶僮客斷後，擋住從東邊追來的吳兵；
 *       凌操乘輕舟沿江獨進，想在中段的淺灘靠岸截住黃祖。甘寧站定不動就會「引弓」射他（Q 錦帆打水上的人會擊飛）。
 *       射殺凌操後追兵退去，護著黃祖回到夏口營即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, boss, rout, TROOPS, PEOPLE } from '../kit.ts';
import { GN_PEOPLE, shoot } from './ganning_kit.ts';
import { ROAD, CAMP, LAND, BOAT0 } from '../maps/ganning_xiakou.ts';

const LV = 8, AIM_R = 1100, AIM_T = 1, ARROW = 340, LC_AT = 20;
const WU = { spec: TROOPS.wu, name: '吳兵', hp: 380, maxHp: 380, atk: 22, ms: 250 };

export default {
  id: 'ganning-1', map: 'ganning_xiakou', hero: 'ganning', gold: 0,
  title: '第 1 章　夏口・射殺凌操', year: '建安八年（203）',
  brief: {
    quote: [{ text: '權討祖，祖軍敗奔走，追兵急，寧以善射，將兵在後，射殺校尉凌操。', src: '《三國志·吳書·甘寧傳》注引《吳書》' }],
    text: '甘寧少年時是巴郡有名的游俠，身上掛著鈴鐺，人聽到鈴聲就知道是他。後來他帶著僮客投劉表、再投江夏太守黃祖，黃祖只把他當平常人看待。這一年孫權西征黃祖，黃祖兵敗西逃。',
    goals: ['斷後：擋住追兵，護黃祖退回夏口營', '射殺乘輕舟獨進的凌操'],
  },
  words: { ally: '僮客', foe: '吳兵' },
  stars: [
    { text: '如史：凌操中流矢——在江上就射殺他', ok: (m) => !m.vars.landed },
    { text: '黃祖的生命保住一半以上', ok: (m) => m.vars.zuMin >= 0.5 },
    { text: '僮客與黃祖兵折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
  ],
  steps: [
    { // 1. 斷後：凌操乘輕舟獨進
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = 8300; me.y = 2300;
        V.t0 = w.t; V.waveT = 2; V.zuMin = 1; V.shots = 0;
        V.zu = ally(w, PEOPLE.huangzu, 7700, 2250, LV); V.zu.name = '黃祖';
        V.zu.maxHp = V.zu.hp = 2600;
        w.addBuff(V.zu, { id: '敗走', t: 9999, ms: -0.6 }); // 年老、敗兵：走得慢
        V.guard = Array.from({ length: 5 }, (_, i) => { const u = m.recruit(7600 + (i % 3) * 60, 2180 + Math.floor(i / 3) * 120, '黃祖兵'); u.spec = TROOPS.huangzu; m.join(u, V.zu); return u; });
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 90 - (i % 3) * 50, me.y - 70 + Math.floor(i / 3) * 140, '僮客'); m.join(u, me); return u; });
        V.foes = [];
        m.card('少有氣力，好游俠……負毦帶鈴，民聞鈴聲，即知是寧。', '《甘寧傳》');
        m.after(4, () => m.card('住止常以繒錦維舟，去或割棄，以示奢也。', '《甘寧傳》注引《吳書》'));
        m.after(8, () => m.line('黃祖', '吳兵追上來了！甘寧，你在後面擋著！'));
        m.after(11, () => m.line('甘寧', '（黃祖待我如凡人……也罷，今日讓他看看甘興霸。）'));
        m.mark('zu', V.zu.x, V.zu.y, '黃祖', true, V.zu);
        m.obj('rear', '斷後：護黃祖退回夏口營');
        m.after(LC_AT, () => {
          V.lc = boss(w, GN_PEOPLE.lingcao, BOAT0[0], BOAT0[1], { name: '凌操', hp: 1600, atk: 46, armor: 6, ms: 260, caster: false, gold: 200, xp: 400 });
          V.b = m.boat(V.lc, { x: BOAT0[0], y: BOAT0[1], sp: 170, goal: [3600, 3060], small: true, flag: '#c0302a', land: true,
            landOk: (x, y) => SG.gd(x, y, LAND[0], LAND[1]) < 520,
            onLand: () => { V.landed = true; V.lc.caster = true; m.line('凌操', '黃祖休走！'); m.big('凌操登岸了！'); } });
          m.mark('lc', BOAT0[0], BOAT0[1], '凌操', false, V.lc);
          m.big('凌操乘輕舟獨進！');
          m.line('凌操', '黃祖老賊，看你往哪裡逃！');
          m.after(3, () => m.line('提示', '凌操想在前面的淺灘靠岸截住黃祖。走到江邊站定不動，就會「引弓」射他；Q 錦帆打到水上的人會擊飛。'));
          m.obj('lc', '射殺凌操');
        });
      },
      tick(m, w) { return m.vars.lc && !m.vars.lc.alive; },
    },
    { // 2. 射殺凌操：追兵退去
      enter(m, w) {
        const V = m.vars;
        m.done('lc'); m.unmark('lc');
        m.card('寧以善射，將兵在後，射殺校尉凌操。', '《甘寧傳》注引《吳書》');
        if (!V.landed) m.after(2.5, () => m.card('輕舟獨進，中流矢死。', '《凌統傳》'));
        m.after(4, () => { rout(m, w, V.foes, [9100, 2300]); m.line('吳兵', '校尉中箭了！退！'); });
        m.mark('camp', CAMP[0], CAMP[1], '夏口營');
      },
      tick(m, w) { return m.near(m.vars.zu, CAMP[0], CAMP[1], 380); },
    },
    { // 3. 回營
      enter(m) {
        m.done('rear'); m.unmark('camp'); m.unmark('zu');
        m.card('祖旣得免，軍罷還營，待寧如初。', '《甘寧傳》注引《吳書》');
        m.after(4, () => m.card('飛白祖，聽寧之縣。招懷亡客并義從者，得數百人。……於是歸吳。', '《甘寧傳》注引《吳書》、正文'));
        m.after(8, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars, zu = V.zu;
    if (!me.alive) { m.lose('甘寧陣亡'); return; }
    if (!zu) return;
    if (!zu.alive) { m.lose('黃祖被追兵擒殺'); return; }
    V.zuMin = Math.min(V.zuMin, zu.hp / zu.maxHp);
    // 黃祖：沿大路往西走，不戀戰
    const I = zu.input;
    const nxt = ROAD.find((p) => p[0] < zu.x - 60) || CAMP;
    I.target = null; I.engage = false;
    I.moveTo = SG.gd(zu.x, zu.y, CAMP[0], CAMP[1]) > 200 ? nxt.slice() : null;
    // 追兵：一波波從東邊來，衝向黃祖
    if (m.i === 0) {
      V.waveT -= dt;
      if (V.waveT <= 0) {
        V.waveT = 8; V.wi2 = (V.wi2 || 0) + 1;
        const n = 3 + Math.min(3, Math.floor(V.wi2 / 2));
        for (let i = 0; i < n; i++) V.foes.push(m.foe('huangjin', 9000, 2200 + i * 50, WU));
      }
    }
    for (const u of V.foes) if (u.alive && !u.rout && !(u.target && u.target.alive)) u.home = [zu.x, zu.y];
    // 凌操：船停住了就往淺灘划；登岸後去追黃祖
    const lc = V.lc, b = V.b;
    if (lc && lc.alive) {
      if (lc.boat && !b.goal) b.goal = [LAND[0], LAND[1] - 140];
      if (!lc.boat && !(lc.target && lc.target.alive && lc.target !== me)) lc.home = [zu.x, zu.y];
      // 引弓：甘寧站定（沒在走、沒出招），凌操在射程內就引弓
      const mI = me.input;
      if (mI.target === lc && lc.boat) { mI.target = null; mI.engage = false; }
      const d = SG.gd(me.x, me.y, lc.x, lc.y);
      if (!me.chan && !me.boat && d < AIM_R && !mI.moveTo && !(mI.wp && mI.wp.length) && !me.act && !(mI.target && mI.target.alive))
        m.chan(me, AIM_T, '引弓', () => { if (lc.alive) { shoot(w, me, lc, ARROW); V.shots++; } });
    }
  },
};
